import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadIssueListStatus: 'idle',
    loadIssueListError: undefined as any,
    loadIssueListLastParams: undefined as string | undefined,
    createIssueStatus: 'idle',
    createIssueError: undefined as any,
    updateIssueStatus: 'idle',
    updateIssueError: undefined as any,
    deleteIssueStatus: 'idle',
    deleteIssueError: undefined as any,

    issueList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false
}
export const loadIssueList = createAsyncThunk('issueSlice/loadIssueList', async ({ forceReload=false }: any, { rejectWithValue, getState }: any) => {
    const { loadIssueListLastParams } = getState().issueSlice
    const url = `/api/ixweb/nurismeldung/`

    let _allParams: any = new URLSearchParams(url.split('?')[1])
    _allParams.sort()
    _allParams = _allParams.toString()

    if (_allParams === loadIssueListLastParams && !forceReload) {
        return
    }

    const res = await client.get(
        url,
        {
        })

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { data: res.data.data, params: _allParams }
        }
    } else {  // backend response
        return { data: res.data, params: _allParams }
    }
},
{
    condition: (_, { getState }) => {
        const state = getState() as any
        const reducerStatus = state.issueSlice.loadIssueListStatus
        return reducerStatus !== 'preloaded'
    }
})
export const createIssue = createAsyncThunk('issueSlice/createIssue', async (issue: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/nurismeldung/`


    const reducerStatus = (getState() as any).issueSlice.loadIssueListStatus
    let res: any = {}
    if (reducerStatus === 'preloaded') {
        res = issue
    } else {
        res = await client.post(url, prepareData(issue))
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...issue, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const updateIssue = createAsyncThunk('issueSlice/updateIssue', async (issue: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/nurismeldung/${issue.HDR_ID}/`


    const reducerStatus = (getState() as any).issueSlice.loadIssueListStatus
    let res: any = {}
    if (reducerStatus === 'preloaded') {
        res = issue
    } else {
        res = await client.put(url, prepareData(issue))
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return issue
        }
    } else {  // backend response
        return res.data
    }
})
export const deleteIssue = createAsyncThunk('issueSlice/deleteIssue', async (id: any, { rejectWithValue, getState }: any) => {
    const url = `/api/ixweb/nurismeldung/${id}/`


    const reducerStatus = (getState() as any).issueSlice.loadIssueListStatus
    let res: any = {}
    if (reducerStatus !== 'preloaded') {
        res = await client.delete(
            url,
            {
            }
        )
    }

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return id
        }
    } else {  // backend response
        return id
    }
})

const IssueSlice = createSlice({
    name: 'issueSlice',
    initialState,
    reducers: {
        resetloadIssueListError: (state) => {
            state.loadIssueListError = undefined
        },
        resetcreateIssueError: (state) => {
            state.createIssueError = undefined
        },
        resetupdateIssueError: (state) => {
            state.updateIssueError = undefined
        },
        resetdeleteIssueError: (state) => {
            state.deleteIssueError = undefined
        },
        removeFromIssueListById: (state, action) => {
            state.issueList = state.issueList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        preloadData: (state, action) => {
            state.issueList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIssueListStatus = 'preloaded'
            state.loadIssueListLastParams = ''
        },
        clearPreloadedData: (state) => {
            state.issueList = []
            state.loadIssueListStatus = 'idle'
            state.loadIssueListLastParams = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIssueList.pending, (state) => {
            state.loadIssueListStatus = 'pending'
            state.loadIssueListError = undefined
        })
        builder.addCase(loadIssueList.fulfilled, (state, action) => {
            state.loadIssueListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIssueListLastParams = action.payload.params

            state.issueList = action.payload.data
        })
        builder.addCase(loadIssueList.rejected, (state, action) => {
            state.loadIssueListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIssueListError = action.error.message
            } else {
                state.loadIssueListError = action.payload
            }
        })

        builder.addCase(createIssue.pending, (state) => {
            state.createIssueStatus = 'pending'
            state.createIssueError = undefined
        })
        builder.addCase(createIssue.fulfilled, (state, action) => {
            state.createIssueStatus = 'idle'


            state.issueList = [...state.issueList, Array.isArray(action.payload) ? action.payload[0] : action.payload]
        })
        builder.addCase(createIssue.rejected, (state, action) => {
            state.createIssueStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createIssueError = action.error.message
            } else {
                state.createIssueError = action.payload
            }
        })

        builder.addCase(updateIssue.pending, (state) => {
            state.updateIssueStatus = 'pending'
            state.updateIssueError = undefined
        })
        builder.addCase(updateIssue.fulfilled, (state, action) => {
            state.updateIssueStatus = 'idle'


            let updatedItems = Array.isArray(action.payload) ? action.payload : [action.payload]
            for (let updatedItem of updatedItems) {
                const i = state.issueList.findIndex((x: any) => x.HDR_ID === updatedItem.HDR_ID)
                if (i === -1) { state.issueList.push(updatedItem) }
                else { state.issueList[i] = { ...state.issueList[i], ...updatedItem } }
            }
        })
        builder.addCase(updateIssue.rejected, (state, action) => {
            state.updateIssueStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateIssueError = action.error.message
            } else {
                state.updateIssueError = action.payload
            }
        })

        builder.addCase(deleteIssue.pending, (state) => {
            state.deleteIssueStatus = 'pending'
            state.deleteIssueError = undefined
        })
        builder.addCase(deleteIssue.fulfilled, (state, action) => {
            state.deleteIssueStatus = 'idle'


            if (Array.isArray(action.payload)) {
                state.issueList = state.issueList.filter((x: any) => !action.payload.includes(x.HDR_ID))
            } else {
                state.issueList = state.issueList.filter((x: any) => x.HDR_ID !== action.payload)
            }
        })
        builder.addCase(deleteIssue.rejected, (state, action) => {
            state.deleteIssueStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteIssueError = action.error.message
            } else {
                state.deleteIssueError = action.payload
            }
        })

    }
})

export const {
    resetloadIssueListError,
    resetcreateIssueError,
    resetupdateIssueError,
    resetdeleteIssueError,
    removeFromIssueListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    preloadData,
    clearPreloadedData,
} = IssueSlice.actions
export default IssueSlice.reducer
